import { useState, useEffect } from 'react';
import { ICardPayFields } from '../../interfaces';
import { createHasFieldBeenTracked, hasKey } from '../utils/inputTracking';

const useTrackField = (
  fieldsState: ICardPayFields,
  billingMethod: string,
  fieldTracking?: (field: string) => void
) => {
  const [hasFieldBeenTracked, setHasFieldHasBeenTracked] = useState(createHasFieldBeenTracked());

  const shouldTrackField = (fieldName: string) =>
    hasKey(fieldsState, fieldName) &&
    fieldsState[fieldName].isTouched &&
    hasKey(hasFieldBeenTracked, fieldName) &&
    !hasFieldBeenTracked[fieldName] &&
    !!fieldTracking &&
    typeof fieldTracking === 'function' &&
    !!window.analytics;

  useEffect(() => {
    if (!fieldTracking) return;
    Object.entries(fieldsState).map((field) => {
      const fieldName: string = field[0] as string;
      if (shouldTrackField(fieldName)) {
        fieldTracking(fieldName);
        return setHasFieldHasBeenTracked({
          ...hasFieldBeenTracked,
          [fieldName]: true,
        });
      }
      return '';
    });
  }, [billingMethod, fieldsState, hasFieldBeenTracked]);
};

export default useTrackField;
